"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SecureConversationMessageHeader_1 = __importDefault(require("./SecureConversationMessageHeader"));
const AsymmetricSecurityHeader_1 = __importDefault(require("./AsymmetricSecurityHeader"));
const SymmetricSecurityHeader_1 = __importDefault(require("./SymmetricSecurityHeader"));
const SequenceHeader_1 = __importDefault(require("./SequenceHeader"));
const Bucket_1 = __importDefault(require("../ua/Bucket"));
const ExpandedNodeId_1 = __importDefault(require("../ua/ExpandedNodeId"));
const service_1 = require("../ua/service");
const MessageType_1 = require("./MessageType");
class ChunkHeader {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.Header = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Header, (_b !== null && _b !== void 0 ? _b : new SecureConversationMessageHeader_1.default()));
        this.SecurityHeader = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SecurityHeader, (_d !== null && _d !== void 0 ? _d : new AsymmetricSecurityHeader_1.default()));
        this.SequenceHeader = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.SequenceHeader, (_f !== null && _f !== void 0 ? _f : new SequenceHeader_1.default()));
    }
    // public encode(): ArrayBuffer {
    //   const bucket = new Bucket()
    //   bucket.writeStruct(this.Header)
    //   switch (this.Header.MessageType) {
    //     case MessageTypeOpenSecureChannel: {
    //       bucket.writeStruct(this.AsymmetricSecurityHeader)
    //       break
    //     }
    //     case MessageTypeMessage:
    //     case MessageTypeCloseSecureChannel: {
    //       bucket.writeStruct(this.SymmetricSecurityHeader)
    //       break
    //     }
    //     default:
    //       break
    //   }
    //   bucket.writeStruct(this.SequenceHeader)
    //   return bucket.bytes
    // }
    decode(b, position) {
        const bucket = new Bucket_1.default(b, position);
        bucket.readStruct(this.Header);
        switch (this.Header.MessageType) {
            case MessageType_1.MessageTypeOpenSecureChannel: {
                this.SecurityHeader = new AsymmetricSecurityHeader_1.default();
                bucket.readStruct(this.SecurityHeader);
                break;
            }
            case MessageType_1.MessageTypeMessage:
            case MessageType_1.MessageTypeCloseSecureChannel: {
                this.SecurityHeader = new SymmetricSecurityHeader_1.default();
                bucket.readStruct(this.SecurityHeader);
                break;
            }
            default:
                break;
        }
        bucket.readStruct(this.SequenceHeader);
        return bucket.position;
    }
}
exports.ChunkHeader = ChunkHeader;
class Message {
    constructor(options) {
        var _a, _b, _c, _d, _e;
        this.ChunkHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ChunkHeader, (_b !== null && _b !== void 0 ? _b : new ChunkHeader()));
        this.TypeId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.TypeId, (_d !== null && _d !== void 0 ? _d : new ExpandedNodeId_1.default()));
        this.Service = (_e = options) === null || _e === void 0 ? void 0 : _e.Service;
    }
    decode(b, position) {
        // let pos = 0
        position = this.ChunkHeader.decode(b);
        position = this.ChunkHeader.SequenceHeader.decode(b, position);
        const { typeId, service } = service_1.decodeService(b, position);
        this.TypeId = typeId;
        this.Service = service;
        return b.byteLength;
    }
    encode() {
        const body = new Bucket_1.default();
        // body.writeStruct(this.MessageHeader)
        switch (this.ChunkHeader.Header.MessageType) {
            case MessageType_1.MessageTypeOpenSecureChannel: {
                body.writeStruct(this.ChunkHeader.SecurityHeader);
                break;
            }
            case MessageType_1.MessageTypeMessage:
            case MessageType_1.MessageTypeCloseSecureChannel: {
                body.writeStruct(this.ChunkHeader.SecurityHeader);
                break;
            }
            default:
                throw new Error(`invalid message type ${this.ChunkHeader.Header.MessageType}`);
        }
        body.writeStruct(this.ChunkHeader.SequenceHeader);
        body.writeStruct(this.TypeId);
        body.writeStruct(this.Service);
        this.ChunkHeader.Header.MessageSize = 12 + body.bytes.byteLength;
        const bucket = new Bucket_1.default();
        bucket.writeStruct(this.ChunkHeader.Header);
        bucket.write(body.bytes);
        return bucket.bytes;
    }
}
exports.Message = Message;
